export default __webpack_public_path__ + "static/media/H_Helicoptero.b2283107.svg";